export default (username) =>
`<div id="header" class="fsb">
	<span>
		<img src="img/logo_h1.png">
		<img src="img/logo_h2.png">
	</span>
	<span>
		<ul class="menu">
			<li>Organização
				<ul>
					<li hash="#companies">Empresas</li>
					<li hash="#suppliers">Fornecedores</li>
					<li hash="#customers">Clientes</li>
					<li hash="#carriers">Transportadores</li>
					<li hash="#devices">Dispositivos</li>
				</ul>
			</li>
			<li>Catálogo
				<ul>
					<li hash="#units">Unidades&nbsp;de&nbsp;Medida</li>
					<li hash="#classes">Classes</li>
					<li hash="#categories">Categorias</li>
					<li hash="#manufacturers">Fabricantes</li>
					<li hash="#programs">Programas</li>
					<li hash="#products">Produtos&nbsp;e&nbsp;Classificações</li>
				</ul>
			</li>
			<li>Armazenamento
				<ul>
					<li hash="#warehouses">Armazéns</li>
					<li hash="#locations">Posições</li>
					<li hash="#stocks">Estoques</li>
					<li hash="#transactions">Transações</li>
					<li hash="#inventories">Inventários</li>
					<li hash="#replenishments">Ressuprimentos</li>
				</ul>
			</li>
			<li>Movimentação
				<ul>
					<li hash="#input-orders">Pedidos&nbsp;de&nbsp;Entrada</li>
					<li hash="#output-orders">Pedidos&nbsp;de&nbsp;Saída</li>
					<li hash="#inputs">Entradas</li>
					<li hash="#lots">Lotes</li>
					<li hash="#outputs">Saídas</li>
				</ul>
			</li>
			<li>Comercial
				<ul>
					<li hash="#price-lists">Listas&nbsp;de&nbsp;Preços</li>
					<li hash="#payment-terms">Condições&nbsp;de&nbsp;Pagamento</li>
					<li hash="#cfops">CFOPs</li>
				</ul>
			</li>
			<li>Faturamento
				<ul>
					<li hash="#invoices">Notas&nbsp;Fiscais</li>
					<li hash="#invoice-lots">Lotes&nbsp;de&nbsp;Notas</li>
				</ul>
			</li>
			<li>Sistema
				<ul>
					<!-- <li hash="#endpoints">Endpoints&nbsp;da&nbsp;API</li> -->
					<li hash="#import-center">Central&nbsp;de&nbsp;Importação</li>
					<li hash="#groups">Grupos&nbsp;e&nbsp;Permissões</li>
					<li hash="#users">Usuários&nbsp;e&nbsp;Associações</li>
					<li hash="#logs">Auditoria&nbsp;de&nbsp;Eventos</li>
					<li hash="#integration-events">Central&nbsp;de&nbsp;Integrações</li>
					<li hash="#logout">Logout&nbsp;do&nbsp;Usuário</li>
					<li hash="#about">Sobre o Sistema</li>
				</ul>
			</li>
		</ul>
		<div id="identification">
			Usuário: ${username}
		</div>
	</span>
</div>
<div id="workarea">
</div>`;

